import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { VIDEO_EDITOR } from "@/constants/expert-constants";

export const useOrgCommunityVideoExpertiseFeedStore = defineSmartFeedPiniaStore(
  "org-community-video-expertise-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        expertise: {
          key: "expertise",
          payload: VIDEO_EDITOR,
        },
      },
      metadata: {
        lastId: Number.MAX_SAFE_INTEGER,
      },
    }),
    getters: {
      feedUrl() {
        return "/expert/community";
      },
    },
  },
);
